import { render } from "./MatchEventFull.vue?vue&type=template&id=214227f1&scoped=true"
import script from "./MatchEventFull.vue?vue&type=script&lang=js"
export * from "./MatchEventFull.vue?vue&type=script&lang=js"

import "./MatchEventFull.vue?vue&type=style&index=0&id=214227f1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-214227f1"]])

export default __exports__